module.exports = __webpack_public_path__ + "static/media/whyDangerous.d5b8bca8.mp3";